import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '@/context/CartContext';
import { ProductCard } from '@/components/ProductCard';
import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const WishlistPage = () => {
  const { wishlist } = useCart();

  if (wishlist.length === 0) {
    return (
      <div className="max-h-[60vh] flex flex-col items-center justify-center" data-testid="empty-wishlist">
        <Heart className="w-16 h-16 text-muted-foreground mb-4" />
        <h2 className="font-outfit font-semibold text-2xl mb-4">Your wishlist is empty</h2>
        <p className="text-muted-foreground mb-6">Save your favorite items here!</p>
        <Link to="/products">
          <Button className="rounded-full px-8 py-6 bg-primary text-primary-foreground hover:bg-primary/90 font-bold" data-testid="browse-products-button">
            Browse Products
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8" data-testid="wishlist-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-outfit font-semibold text-3xl md:text-4xl mb-8" data-testid="wishlist-heading">
          My Wishlist ({wishlist.length})
        </h1>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10" data-testid="wishlist-grid">
          {wishlist.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};
